<div class="readonlytbox">
  <div class="milestone2-tabs">
    <div class="rtnav ui-g">
      <div class="ui-g-6 msgbox-6">
        @for (message of msgsMilestone2InvoiceDetails; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
      </div>
      @if (!paymentMilestone2btnNav) {
        <div class="ui-g-5"></div>
      }
      @if (paymentMilestone2btnNav) {
        <div class="ui-g-5">
          <button
            type="button"
            pButton
            (click)="editMilestone2PaymentCancel(formFrontlineWorker)"
            class="ui-button-secondary flat fl-rt">
            Cancel
          </button>
          <button
            type="submit"
            pButton
            (click)="onSubmitMilestone2PaymentInvoice(formFrontlineWorker)"
            class="flat btnmr fl-rt">
            Save
          </button>
        </div>
      }
      <div class="ui-g-1 edit-history-icon">
        <button
          class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
          pTooltip="Edit"
          (click)="editMilestone2Payment()"
          tooltipPosition="bottom"
          [disabled]="isOptOutPartner">
          Edit
        </button>
      </div>
    </div>
    <form [formGroup]="formFrontlineWorker">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Tier 1</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Incentive Type</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="payoutMetric" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Payment Amount</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier1PaymentAmount" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Initial Tier Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier1MetDate" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Paid Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            [readonlyInput]="isReadonlyMilestone2Payment"
            formControlName="tier1PaidDate"
            placeholder="mm/dd/yy"
            dateFormat="mm/dd/yy"
            [showOnFocus]="false"
            [showIcon]="isReadonlyMilestone2Payment === false"
            [class.readonlycaltb]="isReadonlyMilestone2Payment === true"
            [defaultDate]="maxYearDate"
            [iconDisplay]="'input'"
            [showIcon]="true">
          </p-datepicker>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier1InvoiceNumber" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Payment Central Transaction ID
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier1PaymentCentralTransactionId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Document Number</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier1PaymentDocumentId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            [options]="paymentStatus"
            [readonly]="isReadonlyMilestone2Payment"
            [class.readonlydd]="isReadonlyMilestone2Payment === true"
            formControlName="tier1PaymentStatus"
            placeholder="--SELECT--"
            optionLabel="paymentStatusName"></p-select>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Tier 2</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Engagement Type</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="payoutMetric" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Payment Amount</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier2PaymentAmount" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Date Tier Met</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier2MetDate" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Paid Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            [readonlyInput]="isReadonlyMilestone2Payment"
            formControlName="tier2PaidDate"
            placeholder="mm/dd/yy"
            dateFormat="mm/dd/yy"
            [showOnFocus]="false"
            [showIcon]="isReadonlyMilestone2Payment === false"
            [class.readonlycaltb]="isReadonlyMilestone2Payment === true"
            [defaultDate]="maxYearDate"
            [iconDisplay]="'input'"
            [showIcon]="true">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier2InvoiceNumber" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Payment Central Transaction ID
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier2PaymentCentralTransactionId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Document Number</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier2PaymentDocumentId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            [options]="paymentStatus"
            [readonly]="isReadonlyMilestone2Payment"
            [class.readonlydd]="isReadonlyMilestone2Payment === true"
            formControlName="tier2PaymentStatus"
            placeholder="--SELECT--"
            optionLabel="paymentStatusName"></p-select>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Tier 3</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Engagement Type</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="payoutMetric" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Payment Amount</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier3PaymentAmount" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Date Tier Met</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="tier3MetDate" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Paid Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            [readonlyInput]="isReadonlyMilestone2Payment"
            formControlName="tier3PaidDate"
            placeholder="mm/dd/yy"
            dateFormat="mm/dd/yy"
            [showOnFocus]="false"
            [showIcon]="isReadonlyMilestone2Payment === false"
            [class.readonlycaltb]="isReadonlyMilestone2Payment === true"
            [defaultDate]="maxYearDate"
            [iconDisplay]="'input'"
            [showIcon]="true">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier3InvoiceNumber" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Payment Central Transaction ID
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier3PaymentCentralTransactionId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Document Number</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyMilestone2Payment"
            formControlName="tier3PaymentDocumentId" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            [options]="paymentStatus"
            [readonly]="isReadonlyMilestone2Payment"
            [class.readonlydd]="isReadonlyMilestone2Payment === true"
            formControlName="tier3PaymentStatus"
            placeholder="--SELECT--"
            optionLabel="paymentStatusName"></p-select>
        </div>
      </div>
    </form>
  </div>
</div>
